import { useCallback, useEffect } from 'preact/hooks';
import { api } from '../lib/api.js';
import { useFetch } from '../lib/useFetch.js';
import type { RoomsResponse } from '../lib/types.js';

const REFRESH_MS = 5000;

export function Rooms() {
  const fetchRooms = useCallback(() => api.get<RoomsResponse>('/api/admin/rooms'), []);
  const rooms = useFetch(fetchRooms, []);

  useEffect(() => {
    const id = setInterval(rooms.reload, REFRESH_MS);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const list = rooms.data?.rooms ?? [];

  return (
    <div>
      <h1 class="page-title">Live rooms</h1>
      <div class="hint" style={{ marginBottom: 12 }}>
        Auto-refreshes every 5s.
      </div>
      {rooms.error && <div class="error-banner">{rooms.error}</div>}

      <div class="card">
        {list.length === 0 && !rooms.loading && <div class="empty">No active rooms.</div>}
        {list.length > 0 && (
          <div style={{ overflowX: 'auto' }}>
            <table class="grid">
              <thead>
                <tr>
                  <th>Room</th>
                  <th>Map</th>
                  <th>Mode</th>
                  <th>Phase</th>
                  <th>Players</th>
                  <th>Tick</th>
                  <th>Tick p50</th>
                  <th>Tick p99</th>
                  <th>Shots</th>
                  <th>Hits</th>
                </tr>
              </thead>
              <tbody>
                {list.map((r) => (
                  <tr key={r.id}>
                    <td>
                      <code>{r.id}</code>
                    </td>
                    <td>{r.mapId}</td>
                    <td>{r.mode}</td>
                    <td>{r.phase}</td>
                    <td>{r.players}</td>
                    <td>{r.tick}</td>
                    <td>{r.tickP50Ms.toFixed(1)}ms</td>
                    <td>{r.tickP99Ms.toFixed(1)}ms</td>
                    <td>{r.shots}</td>
                    <td>{r.hits}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
